import { Component, ElementRef, OnInit, QueryList, ViewChildren, Renderer2, HostListener } from '@angular/core';
import { ConstantsService } from '../services/constants.service';
import { CacheService } from '../services/cache.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-gift',
  templateUrl: './gift.component.html',
  styleUrls: ['./gift.component.scss']
})
export class GiftComponent implements OnInit {
  @ViewChildren('featureEl') featureEls!: QueryList<ElementRef>;
  @ViewChildren('headerEl') headerEls!: QueryList<ElementRef>;
  isLogin:boolean = false;
  from = "giftHome";
  isMobile: boolean = false;

  private intersectionObserver: IntersectionObserver | null = null;
  private intersectionObserver2: IntersectionObserver | null = null;

  constructor(
    public constants: ConstantsService,
    private authenticate: CacheService,
    public userService: UserService,
    public renderer: Renderer2
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  async ngOnInit() {
    await this.authcall();
    this.checkScreenSize();
    // this.authenticate.animateUI('easeinoutGift');
  }

  ngAfterViewInit() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const target = entry.target as HTMLElement;

        if (entry.isIntersecting) {
          const index = parseInt(target.dataset.index || '0');
          target.style.transitionDelay = `${index * 100}ms`; // e.g. 0ms, 200ms, 400ms
          this.renderer.addClass(entry.target, 'in-view');
        } else {
          this.renderer.removeClass(entry.target, 'in-view');
        }
      });
    }, { threshold: 0 });
  
    this.intersectionObserver2 = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const target = entry.target as HTMLElement;

        if (entry.isIntersecting) {
          const index = parseInt(target.dataset.index || '0');
          target.style.transitionDelay = `${index * 100}ms`; // e.g. 0ms, 200ms, 400ms
          this.renderer.addClass(entry.target, 'in-view');
        } else {
          this.renderer.removeClass(entry.target, 'in-view');
        }
      });
    }, { threshold: 0.25 });

    this.featureEls.forEach(el => {
      this.intersectionObserver2.observe(el.nativeElement);
    });

  
  //  Header-specific: observe only header-strong texts and header-image
  const headerElements = document.querySelectorAll('.header-image');
  headerElements.forEach(el => this.intersectionObserver.observe(el));

  this.headerEls.forEach(el => {
    this.intersectionObserver.observe(el.nativeElement);
  });

  }

  ngOnDestroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  public async authcall() {
    await this.authenticate
      .getAuthUser()
      .then(async (data) => {
        let { login } = await data;
        this.isLogin = login;
      })
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth <= 767;
  }

}
